import React from 'react';
import { capitalize, get } from 'lodash';
import PopoverTrigger from '../../PopoverTrigger';

// From Urjanet API:
// https://urjanet.zendesk.com/hc/en-us/articles/115004564183-What-do-the-various-Enrollment-Extraction-and-Monitoring-Statuses-in-Urjanet-Portal-mean-
const AccountStatusLookup = Object.freeze({
  AGED_BILL: 'Account has not posted a recent bill',
  NAVIGATION_FAILURE:
    'An issue with the navigation template prevented successful extraction',
  BLOCKED: 'Access to the account is blocked by the website',
  DEACTIVATED: 'Account not required in delivery',
  ACCOUNT_MISSING: 'Requested account is missing from the website	',
  FINALLED: 'Account is closed',
  INACTIVE:
    'Account exists but is inactive (no bills or activity for >100 days)',
  LOGIN_FAILURE: 'A login failure is confirmed for this account',
  LOGIN_UPDATED:
    'The credentials have been updated after failing but have not been tested since',
  ENROLLMENT_EVENT: 'Requested account is the enrollment stage',
  DAQ_PRODUCTION: 'Account is in production via direct acquisition (DAQ)',
  PRODUCTION: 'Account is in production',
  TEMPLATE_FAILURE:
    'An issue with the template prevented successful extraction',
  UNKNOWN: "Account's status is not yet set",
  SOURCE_FORMAT_CHANGE: 'The invoice source changed its format',
  ACCOUNT_NUMBER_CHANGE: 'The account number has changed',
});

// From Urjanet API:
// https://developer.urjanet.net/docs/utilitydataservice-api-documentation.html#header-credential-status
const CredentialStatusLookup = Object.freeze({
  OK: 'Success',
  PENDING: {
    WEBSITE_DOWN: 'Temporary problem in accessing the website',
    UNDER_REVIEW:
      'Urjanet is reviewing the issue and will update the status shortly',
    STATEMENT_UNAVAILABLE:
      'Temporary problem in accessing bills within this credential',
  },
  FIX: {
    LOGIN_FAILURE:
      'Login attempt failed. Update your credentials, and the system will try again.',
    NO_ACCOUNTS_FOUND: '	No accounts found within this credential',
    ACCOUNT_LOCKED:
      'Login failed due to account lockout. Please unlock the account.',
    UNSUPPORTED_CAPTCHA:
      'Login failed due to a captcha required by the utility. In some cases, captcha can be disabled in the utility’s website settings.',
    E_BILL_REQUIRED:
      'Enrollment in electronic billing is required to access online statements.',
  },
});

export function fmtUrjanetAccountStatus(monitoringStatus) {
  if (monitoringStatus in AccountStatusLookup)
    return [monitoringStatus, AccountStatusLookup[monitoringStatus]].join(
      '\t - \t'
    );
  return 'This account is currently being updated in Urjanet. Please check back later.';
}

export function fmtUrjanetCredentialStatus({
  credentialStatus,
  credentialStatusDetail,
}) {
  const eventDetail = _getCredentialStatus(
    credentialStatus,
    credentialStatusDetail
  );
  if (typeof eventDetail === 'string') return eventDetail;
  return (
    <PopoverTrigger popoverContent={eventDetail[1]}>
      {_formatStatus(eventDetail[0])}
    </PopoverTrigger>
  );
}

export function fmtUrjanetCredentialLastSuccess(eventStatus) {
  return eventStatus ? 'Complete' : 'Pending';
}

function _getCredentialStatus(status, statusDetail) {
  switch (status) {
    case 'OK':
      return 'Submitted';
    case 'PENDING':
      return 'Submitted';
    default:
      return [
        // status,
        statusDetail,
        get(CredentialStatusLookup, [status, statusDetail], ''),
      ];
  }
}

const _formatStatus = (status) => (
  <div
    className='text-danger'
    style={{
      width: '100%',
      height: '100%',
      cursor: 'pointer',
    }}
  >
    {status
      .split('_')
      .map((word) => capitalize(word))
      .join('\t \t')}
  </div>
);
